<template>
    <div class="page-homes">
        <CBNavbar @navbar-click="onNavbarClick" />
        <div class="pagess">
            <div class="treasureBowl">{{ $t('value81') }}</div>
            <img src="@/assets/images/background28.png" alt="background28" class="background28">
            <div class="underline"></div>
            <div class="relevantInformation">{{ $t('value82') }}</div>
            <div class="relevantInformationUID">UID</div>
            <el-input class="input1" v-model="referUid" :placeholder="$t('value83')" :disabled="inputJudge" @input="onReferUidInput"></el-input>
            <div class="IntegralData">{{$t('value84')}}</div>
            <el-input class="input2" v-model="pointData" :placeholder="$t('value85')" :disabled="inputJudge" @input="onPointDataInput"></el-input>
            <div class="submitInformation" v-if="!inputJudges" @click="flowSavePointFn">{{$t('value86')}}</div>
        </div>
    </div>
</template>

<script>
import CBNavbar from '@/components/navbar/indexTwo.vue'
import { mapState, mapGetters } from 'vuex'
import { Toast } from 'vant';
// import { MessageBox } from 'element-ui';
import './TreasureBowl.css'
import { ztai,setMyVariable} from "@/web3/index.js"
import { flowSavePoint,getPoint } from "@/api/TreasureBowl.js"
import { locationHrefIndex } from '@/web3/index'
export default {
    name: 'NFTPledge',
    components: {
        CBNavbar,
    },
    data() {
        return {
            input: '865663',
            inputTwo: '15666666.a36',
            inputJudge:false,
            inputJudges:true,
            referUid:'',
            pointData:'',
            offTimer:null,
        }
    },
    computed: {
        ...mapState(['address']),
        ...mapGetters(['isLogin']),
    },
    methods: {
        onPointDataInput(value) {
            // 只允许数字和小数点，且只能有一个小数点
            let filtered = value.replace(/[^0-9.]/g, '');
            const parts = filtered.split('.');
            if (parts.length > 2) {
                filtered = parts[0] + '.' + parts.slice(1).join('');
            }

            // 如果输入是空或者只有一个点，允许继续输入，不做限制
            if (filtered === '' || filtered === '.') {
                this.pointData = filtered;
                return;
            }

            // 转成数字判断大小
            let num = parseFloat(filtered);

            // 如果不是数字，保持原输入（防止输入中断）
            if (isNaN(num)) {
                this.pointData = filtered;
                return;
            }

            // 限制最大值为5000
            if (num > 5000) {
                num = 5000;
            }

            // 保留用户输入的小数格式，避免自动去除末尾0
            // 这里用字符串比较长度，防止用户输入"5000."这种格式被自动转成"5000"
            if (filtered.endsWith('.') || (parts.length === 2 && filtered.endsWith('0'))) {
                this.pointData = filtered;
            } else {
                this.pointData = num.toString();
            }
        },

        onReferUidInput(value) {
            // 只允许数字
            const filtered = value.replace(/\D/g, ''); // \D 匹配非数字，替换为空
            this.referUid = filtered;
        },
        onNavbarClick(value) {
            console.log('Navbar clicked with value:', value); // 处理事件的方法，接收传递的值
            this.$router.push('/')
            // 在这里可以执行其他逻辑
        },
        upData(){
            console.log('填写积分132456',this.address);
            setTimeout(()=>{
                console.log('打印地址')
                this.getPointFn()
            },1500)
            
        },
        //   填写积分
        flowSavePointFn(){
            if(this.referUid==''||this.pointData==''){
                this.$message(this.$t('value121'))
                return
            }
            flowSavePoint({
                walletAddress:this.address,
                referUid:this.referUid,
                pointData:this.pointData,
            }).then((res)=>{
                console.log('填写积分',res);
                this.$message(this.$t('value122'))
                this.inputJudges=true
            })
        },
        //   查询积分
        getPointFn(){
            getPoint(this.address).then((res)=>{
                console.log('查询积分',res);
                if(res.code==200){
                    if(res.data){
                        this.referUid=res.data.referUid
                        this.pointData=res.data.pointData
                        this.inputJudge=true
                    }else{
                        this.inputJudges=false
                    }
                }
            })
        },
        
    },
    watch: {
        address(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.upData();
            }
        }
    },
    mounted(){
        let that=this
        this.upData()
        this.offTimer=setInterval(async ()=>{
            let value=await locationHrefIndex()
            if(value){
            clearInterval(this.offTimer);  
            this.offTimer=null
            }
        },1000)
        this.clears=setInterval(()=>{
            that.showOverlay=that.$store.state.showOverlay
            //监听交易是否完成
            ztai().then((res)=>{
                if (res) {
                    console.log(33);
                    if (that.Authorizationudgmentsstwo==2) {
                        that.Authorizationudgmentsstwo=1
                    }
                    Toast.clear();
                    that.datas.dialogVisible=false
                    this.upData()
                    that.drawer=false
                    let txHash=''
                    setMyVariable(txHash)
                }
            })
        },1000)
    },
    //离开页面时执行函数
    beforeDestroy() {         
        clearInterval(this.clears);  
        this.clears=null
        clearInterval(this.offTimer);  
        this.offTimer=null
    },
}
</script>
<style scoped lang="less">

</style>
